<template>
  <div v-if='loading'>
    <OilForm
      :title='title'
      :items='ImporterConsignmentModel'
      :keys='itemKey'
      :createForm='!id'
      :success-message='message'
      :formCallback='formCallBack'
      @PartyInformationPricePerTonnes='PricePerTonnes'
      @PartyInformationExcise='changeAksiz'
      @PartyInformationVAT='changeVAT'
      @PartyInformationTotalAmountInTons='changeAmountTons'

    >

      <template v-slot:Importer.Id='{input}'>
        <v-select
          v-model='ImporterConsignmentModel.Importer'
          :items='importers'
          :disabled='!input.isEdit'
          label='Выбрать импортера'
          item-value='Id'
          item-text='Name'
          @change='changeImporter'
          hide-no-data
          hide-selected
          return-object
          outlined
          dense
        >
        </v-select>
      </template>
      <template v-slot:GosDeclaration.Id='{input}'>
        <v-select
          v-model='ImporterConsignmentModel.GosDeclaration'
          :items='importerGtds'
          @change='changeGtd'
          label='Выбрать ГТД'
          :disabled='!input.isEdit'
          item-value='Id'
          item-text='Number'
          hide-no-data
          hide-selected
          return-object
          outlined
          dense
        >
        </v-select>
      </template>
      <template v-slot:Invoice.Id='{input}'>
        <v-select
          v-model='ImporterConsignmentModel.Invoice'
          :items='importer_invoices'
          label='Выбрать инвойс'
          item-value='Id'
          item-text='Number'
          :disabled='!input.isEdit'
          @change='changeInvoice'
          hide-no-data
          hide-selected
          return-object
          outlined
          dense
        >
        </v-select>
      </template>
      <template v-slot:Terminal.Id='{input}'>
        <v-select
          v-model='ImporterConsignmentModel.Terminal'
          :items='terminals'
          label='Выбрать базу'
          item-value='Id'
          item-text='Name'
          :disabled='!input.isEdit'
          @change='terminalChange'
          hide-no-data
          hide-selected
          return-object
          outlined
          dense
        >
        </v-select>
      </template>
      <template v-slot:Product.Id='{input}'>
        <v-select
          v-model='ImporterConsignmentModel.Product'
          :items='products'
          label='Выбрать товар'
          item-value='Id'
          item-text='Name'
          @change='changeProduct'
          :disabled='!input.isEdit'
          hide-no-data
          hide-selected
          return-object
          outlined
          dense
        >
        </v-select>
      </template>
      <template v-slot:Total>
        <v-text-field
          v-model='ImporterConsignmentModel.PartyInformation.Total'
          label='Общая стоимость в суммах'
          outlined
          dense
        >
        </v-text-field>
      </template>

      <template v-slot:Registry='{input}' v-if='id'>
        <OilRegistry :call='calculate' :disabled='input.isEdit'
                     :items='ImporterConsignmentModel.OtherExpenses' />
      </template>
      <template v-slot:Information=''>
        <h4>Информация о партии</h4>
      </template>
      <template v-slot:Expense=''>
        <h4>РАСХОДЫ</h4>
      </template>
      <template v-slot:Calculation=''>
        <h4>РАСЧЕТЫ</h4>
      </template>
      <template v-slot:Consumption=''>
        <h4>ИТОГО РАСХОД</h4>
      </template>
      <template v-slot:Calculate='{input}'>
        <v-btn color='primary' @click='count' :disabled='!input.isEdit' >РАСЧИТАТЬ</v-btn>
      </template>
      <template v-slot:Cost=''>
        <h4>Себестоимость товар</h4>
      </template>
    </OilForm>
  </div>
</template>
<script>
import itemKey from './setting/consignment.json'
import { num2str } from '~/utils/functions/MoneyFromString'
import { coreApi } from '~/services/core'
import { debounceTime, distinctUntilChanged, pluck, switchMap } from 'rxjs/operators'
import { consignmentImporterService } from '~/services/ConsignmentImporterService'
import { productsService } from '~/services/ProductsService'


export default {
  props: {
    id: {
      type: String
    }
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    OilRegistry: () => import('@/pages/consignment/setting/registry')
  },
  data() {
    return {
      select_item: [],
      title: 'ПРИХОД',
      ImporterConsignmentModel: {
        PartyInformation: {},
        Expenses: {},
        OtherExpenses: [],
        Amount: 0
      },
      importers: [],
      importerGtds: [],
      importer_invoices: [],
      terminals: [],
      products: [],

      expense: 0,
      otherExpense: 0,

      itemKey: itemKey,
      loading: false
    }
  },

  async created() {

    const importers = await coreApi.get(`importer`)
    this.importers = importers.data || []

    const importerGtds = await coreApi.get(`gtd`)
    this.importerGtds = importerGtds.data || []

    const importer_invoices = await coreApi.get(`importer-invoice`)
    this.importer_invoices = importer_invoices.data || []

    const terminals = await coreApi.get(`terminal`)
    this.terminals = terminals.data || []

    if (this.id) {
      const consignment = await consignmentImporterService.getById(this.id)
      this.ImporterConsignmentModel = consignment.data
      this.terminalChange(this.ImporterConsignmentModel.Terminal)
    }

    this.loading = true
  },
  methods: {

    terminalChange(terminal) {
      if (terminal) {
        this.products = terminal.Products || []
        this.ImporterConsignmentModel.Terminal = { ...terminal }
      }
    },
    PricePerTonnes(amount) {
      const ImCoPa =  this.ImporterConsignmentModel.PartyInformation
      ImCoPa.Total = parseFloat(amount) *
        parseFloat(ImCoPa.TotalAmountInTons)
      this.changeAksiz(ImCoPa.Excise)
      this.changeVAT(ImCoPa.VAT)
    },
    changeGtd(gtd) {
      const ImCoPa =  this.ImporterConsignmentModel.PartyInformation
      ImCoPa.TotalAmountInTons = gtd.TotalQuantityInTons

      this.changeAmountTons(ImCoPa.TotalAmountInTons)

    },
    changeAksiz(count) {
      const ImCoPa =  this.ImporterConsignmentModel.PartyInformation
      ImCoPa.TotalExcise =(parseFloat(ImCoPa.Total) * parseFloat(count)) / 100

      this.changeVAT(ImCoPa.VAT)
    },
    changeVAT(vat) {
      const ImCoPa =  this.ImporterConsignmentModel.PartyInformation
      ImCoPa.RateVat =
        (parseFloat(ImCoPa.Total) +
          parseFloat(ImCoPa.TotalExcise)) * parseFloat(vat) / 100
    },
    changeImporter(importer) {
      this.ImporterConsignmentModel.Importer = importer
    },
    changeProduct(product) {
      this.ImporterConsignmentModel.Product = product
    },
    changeInvoice(invoice) {
      this.ImporterConsignmentModel.Invoice = invoice
    },
    changeAmountTons(ton) {
      const ImCoPa = this.ImporterConsignmentModel.PartyInformation
      ImCoPa.Total = ImCoPa.PricePerTonnes * ton

      this.changeAksiz(ImCoPa.Excise)
      this.changeVAT(ImCoPa.VAT)

    },
    count() {
      this.calculate(this.ImporterConsignmentModel.OtherExpenses)
      // const otherEx = this.ImporterConsignmentModel.OtherExpenses
      
      const ImCoPa =  this.ImporterConsignmentModel.PartyInformation
      this.ImporterConsignmentModel.Amount =
        this.otherExpense + this.expense +
        ImCoPa.Total +
        ImCoPa.TotalExcise

      this.ImporterConsignmentModel.PricePerTonInSoums =
        this.ImporterConsignmentModel.Amount/ImCoPa.TotalAmountInTons

      this.ImporterConsignmentModel.TotalConsignment =
        this.ImporterConsignmentModel.Amount + ImCoPa.RateVat



    },
    async formCallBack(consignment,input,form,func) {
      input.isEdit = false
      if (this.id) {
        await consignmentImporterService.update(consignment)
      } else {
        await consignmentImporterService.create(consignment)
      }
      this.$router.push('/importers-consignments')
      func(this.message)
    },

    calculation() {
      const expenses = this.ImporterConsignmentModel.Expenses
      const keys = Object.keys(expenses)
      let sum1 = 0
      keys.forEach(k => {
        sum1 += parseFloat(expenses[k])
      })
      this.expense = sum1
    },
    /**
     * @param {array} registry
     */
    calculate(registry) {
      let sum = 0
      registry.forEach(({ Expenses1, Expenses2 }) => {
        sum += parseFloat(Expenses1) + parseFloat(Expenses2)
      })
      this.otherExpense = sum
    }
  },
  watch: {
    'ImporterConsignmentModel.TotalConsignment'(price) {
      this.ImporterConsignmentModel.AmountCum = num2str(price)
    },
    'ImporterConsignmentModel.Expenses': {
      deep: true,
      handler() {
        this.calculation()
      }
    },

  },
  computed: {
    message() {
      return this.id ? 'партия удачно изменен' : 'партия удачно создан'
    }


  }

}
</script>

<style scoped>

</style>